"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lumi = _interopRequireDefault(require("./lumi.palette"));
var _lumi2 = _interopRequireDefault(require("./lumi.typography"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = {
  MuiFormControl: {
    styleOverrides: {
      root: {
        '& .MuiFormLabel-root': {
          color: _lumi["default"].common.grey300,
          '&.Mui-focused': {
            color: _lumi["default"].common.grey300
          }
        },
        '& .MuiFormHelperText-root': {
          '&.Mui-error': {
            color: _lumi["default"].common.red400,
            fontSize: 15,
            lineHeight: 1.2,
            fontWeight: 600
          }
        }
      }
    }
  },
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        borderRadius: 8,
        fontSize: _lumi2["default"].fontSize14
      },
      contained: {
        padding: 16,
        backgroundColor: _lumi["default"].primary.main,
        color: _lumi["default"].common.blue400,
        lineHeight: 1.2,
        fontWeight: _lumi2["default"].fontWeightSemiBold,
        boxShadow: 'none',
        '&.Mui-disabled': {
          backgroundColor: _lumi["default"].primary.main,
          color: _lumi["default"].common.blue400,
          lineHeight: 1.2,
          fontWeight: _lumi2["default"].fontWeightSemiBold,
          boxShadow: 'none',
          '&.Mui-disabled': {
            backgroundColor: _lumi["default"].primary.main,
            opacity: 0.5
          },
          '&:hover, &:active': {
            boxShadow: 'none',
            backgroundColor: _lumi["default"].primary.main
          },
          '@media (hover: none)': {
            '&:hover, &:active': {
              boxShadow: 'none !important',
              backgroundColor: "".concat(_lumi["default"].primary.main, " !important")
            }
          }
        }
      },
      outlined: {
        padding: '12px 16px',
        backgroundColor: _lumi["default"].common.white,
        color: _lumi["default"].common.blue400,
        lineHeight: 1.2,
        fontWeight: _lumi2["default"].fontWeightSemiBold,
        border: 'none',
        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.25)'
      },
      text: {
        color: _lumi["default"].text.headingText,
        lineHeight: 1.5,
        fontWeight: _lumi2["default"].fontWeightSemiBold
      },
      textSecondary: {
        color: _lumi["default"].common.grey400
      }
    }
  },
  MuiButtonBase: {
    styleOverrides: {
      root: {
        fontFamily: 'inherit'
      }
    }
  },
  MuiLink: {
    styleOverrides: {
      root: {
        color: _lumi["default"].text.headingText,
        fontSize: 14,
        lineHeight: 1.5,
        fontWeight: _lumi2["default"].fontWeightSemiBold,
        textDecoration: 'none',
        '&.MuiLink-underlineHover:hover': {
          textDecoration: 'none'
        }
      }
    }
  },
  MuiSnackbar: {
    styleOverrides: {
      root: {
        left: 16,
        right: 16,
        opacity: 0.8
      }
    }
  },
  MuiSnackbarContent: {
    styleOverrides: {
      root: {
        backgroundColor: _lumi["default"].text.headingText,
        justifyContent: 'center',
        fontSize: _lumi2["default"].fontSize13,
        fontWeight: _lumi2["default"].fontWeightSemiBold,
        '& .MuiSnackbarContent-message': {
          display: 'flex',
          alignItems: 'center',
          '& .MuiSvgIcon-root': {
            marginRight: 4
          }
        }
      }
    }
  },
  MuiRadio: {
    styleOverrides: {
      root: {
        color: _lumi["default"].common.grey100,
        '&.Mui-checked': {
          color: "".concat(_lumi["default"].common.blue400, " !important")
        }
      }
    }
  },
  MuiLinearProgress: {
    styleOverrides: {
      root: {
        backgroundColor: _lumi["default"].common.blue400
      },
      barColorPrimary: {
        backgroundColor: _lumi["default"].common.blue50
      }
    }
  },
  MuiDivider: {
    styleOverrides: {
      root: {
        background: _lumi["default"].common.grey20,
        borderColor: _lumi["default"].common.grey20
      }
    }
  },
  MuiCheckbox: {
    styleOverrides: {
      root: {
        color: _lumi["default"].common.grey200
      }
    }
  },
  MuiBreadcrumbs: {
    styleOverrides: {
      separator: {
        color: _lumi["default"].common.grey300,
        'html[dir=rtl] &': {
          transform: 'scaleX(-1)'
        }
      }
    }
  },
  MuiTypography: {
    defaultProps: {
      variantMapping: {
        smallTextBold: 'p',
        smallText: 'p'
      }
    }
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        backgroundColor: _lumi["default"].common.white,
        boxShadow: 'none',
        marginBottom: 16
      }
    }
  }
};